
//certifications

 //   http://dev-hydronew.azurewebsites.net/api/Help/Api/GET-api-Patron-GetAllActivity_LocationId


 export const GetAllActivity = (LocationId) => {
    return $.get('Patron/GetAllActivity?LocationId='+LocationId)    
}

export const AddActivity = (model) => {
    return $.post('Patron/AddActivity',model)
 }
 export const UpdateActivity = (model) => {
    return $.post('Patron/UpdateActivity',model)
 }

export const DeleteActivity = (ActivityId) => {
  return $.post('Patron/DeleteActivity?ActivityId='+ActivityId)
}

export const GetActivityDetails = (ActivityId) => {
    return $.get('Patron/GetActivityDetails?ActivityId='+ActivityId)
}

export const GetLocations = () => {
    let havingPools=true;
    return $.get('Location/GetLocations?havingPools='+havingPools);

}

export const GetPools = (locationid) => {    
    return $.get('Pool/GetPools?locationId='+locationid)
}

export const GetAllActivityTypes = () => {    
    return $.get('Patron/GetAllActivityTypes')
}

  




// WEBPACK FOOTER //
// ./src/pages/activitylist/activitylist.service.js